export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a3eef203ddd6196e46937f8fa85912e0.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Service Name */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6">
          サクッとHP
        </h1>

        {/* Main Catchphrase */}
        <p className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mb-4">
          月額3,980円から始める、<br className="sm:hidden" />あなたのお店のホームページ
        </p>

        {/* Sub Catchphrase */}
        <p className="text-lg sm:text-xl lg:text-2xl text-cyan-300 mb-12">
          最短1週間でプロ品質のHPを公開
        </p>

        {/* CTA Button */}
        <a 
          href="https://forms.gle/ztmMFqiChzTiYQCn7"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-10 py-4 bg-amber-500 hover:bg-amber-600 text-white text-lg font-bold rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
        >
          無料で相談する
        </a>
      </div>
    </section>
  );
}